/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { object, func, string } from 'prop-types';

import QASAddressContainer from './QASAddressContainer';
import QASAddressContainerV2 from './QASAddressContainerV2';

import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import {
    getQasSearchSuggestion, getShowValidatedAddressSuggestion,
} from '../../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import { getFeatureFlags, getModalQasRadioBtnSFABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';
import { getFormattedRecipientData } from '../Helpers/Input-Helper';
import { flagOffShowValidatedAddressSuggestion } from '../../../../../../../state/ducks/Checkout/ducks/Common/ducks/AddressSearchQAS/AddressSearchQAS-Actions';
import { enterpriseSaveAddressBook, enterpriseSaveRecipientGiftMessage } from '../../../../../../../state/ducks/MfeCheckout/ducks/CartItem/Recipient/Recipient-Actions';
import { anchorToSection } from '../Helpers/Helper';
import useClickStreamCustomEventsTracking from '../../../../../../helpers/Personalization/useClickstreamCustomEventsTracking';

const QasAddressVerificationModal = ({
    handleCloseAddressBook,
    orderItem,
    pageType,
    parentType,
    recipientGreetingData,
    recipientQASData,
    recipientRedirectTo,
    setButtonTypeQAS,
    setItemRecipientData,
    setRecipientGreetingData,
    typeData,
    orderItemError,
}) => {
    const dispatchAction = useDispatch();
    const history = useHistory();

    const featureFlags = useSelector(getFeatureFlags);
    const suggestionList = useSelector(getQasSearchSuggestion);
    const showAddressValidation = useSelector(getShowValidatedAddressSuggestion);
    const modalQasRadioButtonsSFABTest = useSelector(getModalQasRadioBtnSFABTest);

    let QASAddressContainerComponent = QASAddressContainer;
    if (
        featureFlags['is-qas-modal-with-radio-buttons-enabled'] === 'newflow'
            || (
                featureFlags['is-qas-modal-with-radio-buttons-enabled'] === 'salesforce'
                && modalQasRadioButtonsSFABTest?.campaign?.campaignResponses?.[0]?.userGroup === 'Default'
            )
    ) {
        QASAddressContainerComponent = QASAddressContainerV2;
    }

    const isFireImpression = featureFlags['is-qas-modal-with-radio-buttons-enabled'] === 'salesforce'
        && modalQasRadioButtonsSFABTest?.campaign?.campaignResponses?.[0]?.userGroup;

    useClickStreamCustomEventsTracking({
        salesforceResponse: isFireImpression ? modalQasRadioButtonsSFABTest : null,
        isFireImpression,
        page: { type: pageType },
    });

    const [addressSelected, setAddressSelected] = useState({
        address: {},
        index: null,
        isKeepAddress: false,
    });

    useEffect(() => {
        if (suggestionList.results?.length > 0) {
            setAddressSelected({
                address: suggestionList.results[0],
                index: 0,
                isKeepAddress: false,
            });
        }

        dispatchAction(trackEvent({
            eventCategory: 'Checkout',
            eventAction: 'QAS Modal',
            eventLabel: 'Impression V1',
        }));
    }, []);

    const handleClose = (isClose, recipientData, reason, isError) => {
        if (recipientData?.firstName) {
            const recipientInfo = { ...recipientData, reason: reason !== 'addressBook' ? 'QAS' : null, isError };
            setItemRecipientData(recipientInfo);
            setRecipientGreetingData({});
        }
        // Close addressbook and qas
        handleCloseAddressBook();
        dispatchAction(flagOffShowValidatedAddressSuggestion());
    };

    const handleSubmitAddress = (type = '', dpvIndicator = 'N', isAddressVerified = 'O', addressQASSelected = {}) => {
        const formattedRecipientData = getFormattedRecipientData(recipientQASData, false);

        if (parentType === 'addressbook') {
            const reqObj = {
                recipient: recipientQASData,
                orderItemId: orderItem.cartItemId,
                typeQAS: type,
                addressQASSelected,
                parentType,
                dpvIndicator,
                isAddressVerified,
                handleCallBack: handleClose,
                cartZipCode: orderItem.deliveryInfo?.zipCode,
                cartLocationType: orderItem.deliveryInfo?.locationType,
                itemDTWData: orderItem.deliveryInfo?.deliveryTimeWindow,
            };
            // send in the call back the address selected back and format this one and populate the data
            // according the selection.
            // populate the data through context to recipientForm
            setItemRecipientData(formattedRecipientData);

            dispatchAction(enterpriseSaveAddressBook(reqObj));
        } else {
            // this happend when the user dont select any cgc, card isle or giftmessage
            let greetingData = recipientGreetingData;
            if (!recipientGreetingData?.type && !orderItem?.greetingMessage?.greetingMessage) {
                greetingData = {
                    type: 'giftMessage',
                    data: {
                        message: '',
                        signature: '',
                        occasionCode: '',
                    },
                };
            }

            // save recipient
            const reqObj = {
                recipient: formattedRecipientData,
                history,
                orderItemId: orderItem.cartItemId,
                orderItemIndex: orderItem.orderItemIndex,
                dpvIndicator,
                isAddressVerified,
                checkSameAsDeliveryAddress: recipientQASData.checkSameAsDeliveryAddress,
                useAddressForAll: recipientQASData.useAddressForAll,
                isDigitalProduct: false,
                pageType,
                greetingData,
                pageToRedirect: recipientRedirectTo,
                brandCode: orderItem.product?.brandCode,
                typeQAS: type,
                parentType,
                addressQASSelected,
                handleCallBack: handleClose, // TODO: i cant find who set this-> recipientQASData.handleCallBack,
                cartZipCode: orderItem.deliveryInfo?.zipCode,
                cartLocationType: orderItem.deliveryInfo?.locationType,
                itemDTWData: orderItem.deliveryInfo?.deliveryTimeWindow,
            };
            setItemRecipientData(formattedRecipientData);
            dispatchAction(enterpriseSaveRecipientGiftMessage(reqObj));
            dispatchAction(flagOffShowValidatedAddressSuggestion());
        }

        anchorToSection(`#orderItem-${orderItem.cartItemId}`, 20, false);
    };

    const handleSelectedAddress = (address, index) => {
        setAddressSelected({
            address,
            index,
            isKeepAddress: false,
        });

        dispatchAction(trackEvent({
            eventCategory: 'Checkout',
            eventAction: 'Clicked on Address',
            eventLabel: '',
        }));
    };

    const handleKeepCurrentAddress = () => {
        setAddressSelected({
            address: {},
            index: null,
            isKeepAddress: true,
        });
    };

    const editVerificationQAS = () => {
        dispatchAction(flagOffShowValidatedAddressSuggestion());
        setButtonTypeQAS('editAddress');
        anchorToSection(`#orderItem-${orderItem.cartItemId}`, 20, false);

        trackEvent({
            eventCategory: 'Checkout',
            eventAction: 'Address Verification Modal',
            eventLabel: 'Edit Address',
        });
    };

    const saveVerificationQAS = () => {
        if (suggestionList.results?.length > 0 && !addressSelected.isKeepAddress) {
            let address = addressSelected.address;
            if (suggestionList.results?.length === 1) {
                address = suggestionList.results[0];
            }

            handleSubmitAddress('qasAddressSelection', 'N', 'V', address);
            setButtonTypeQAS('qasAddressSelection');
            dispatchAction(trackEvent({
                eventCategory: 'Checkout',
                eventAction: 'Clicked on Address',
                eventLabel: '',
            }));

            dispatchAction(trackEvent({
                eventCategory: 'Checkout',
                eventAction: 'QAS modal',
                eventLabel: 'Verified',
            }));
        } else {
            handleSubmitAddress('keep', 'N', 'O');
            setButtonTypeQAS('keep');
            anchorToSection(`#orderItem-${orderItem.cartItemId}`, 20, false);
            dispatchAction(trackEvent({
                eventCategory: 'Checkout',
                eventAction: 'Address Verification Modal',
                eventLabel: 'Keep Address',
            }));

            dispatchAction(trackEvent({
                eventCategory: 'Checkout',
                eventAction: 'QAS modal',
                eventLabel: 'Overridden',
            }));
        }
    };

    if (
        !featureFlags?.['is-qas-address-verification-enabled']
        || !showAddressValidation || !recipientQASData
        || !setItemRecipientData
    ) {
        return null;
    }

    return (
        <QASAddressContainerComponent
            addressItemPosition="suggestion"
            addressSelected={addressSelected}
            editVerificationQAS={editVerificationQAS}
            featureFlags={featureFlags}
            handleKeepCurrentAddress={handleKeepCurrentAddress}
            handleSelectedAddress={handleSelectedAddress}
            orderItemError={orderItemError}
            recipientQASData={recipientQASData}
            saveVerificationQAS={saveVerificationQAS}
            showAddressValidation={showAddressValidation}
            suggestionList={suggestionList?.results || []}
            typeData={typeData}
            versionQAS="v1"
        />
    );
};

QasAddressVerificationModal.propTypes = {
    handleCloseAddressBook: func.isRequired,
    orderItem: object.isRequired,
    pageType: string.isRequired,
    parentType: string.isRequired,
    recipientQASData: object.isRequired,
    recipientGreetingData: object.isRequired,
    recipientRedirectTo: string.isRequired,
    setButtonTypeQAS: func.isRequired,
    setItemRecipientData: func.isRequired,
    setRecipientGreetingData: func.isRequired,
    typeData: string,
    orderItemError: string,
};

QasAddressVerificationModal.defaultProps = {
    typeData: '',
    orderItemError: null,
};

export default QasAddressVerificationModal;
